var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#9BA0B1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 19c0-.552.446-1 .999-1H19c.552 0 .999.444.999 1 0 .552-.446 1-.999 1H1C.447 20 0 19.556 0 19zM17.864.72l1.417 1.418c.78.78.78 2.045-.003 2.828L9.38 14.864l-3.723.934c-1.072.27-1.722-.385-1.454-1.454l.934-3.722L15.035.724c.782-.782 2.05-.78 2.829-.003zM9.026 12.39l-1.414-1.414-.669.669-.47 1.883 1.875-.46.678-.678zm6.716-6.716l-1.414-1.418-5.301 5.306 1.413 1.413 5.302-5.301z",
    transform: "translate(-455 -229) translate(455 229)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.106276c003793d89108ed6e3707a7f2b.svg";
export { ForwardRef as ReactComponent };